import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer, staggerItem } from '../../animations/animations';

const otherProjects = [
  {
    title: 'GenAI Content Intelligence Pipeline',
    tags: ['Python', 'FastAPI', 'Celery', 'Gemini API', 'Qdrant', 'Docker'],
    description:
      'Built a 3-tier LLM pipeline (Gemini Flash for triage, Gemini Pro for analysis) to filter 10,000+ daily electronics sector signals into ~20 high-quality articles per day. 93% classification accuracy. Implemented Qdrant for semantic deduplication.',
  },
  {
    title: 'GCP Serverless FinOps Guardrail',
    tags: ['GCP', 'Cloud Functions', 'BigQuery', 'Python', 'IAM'],
    description:
      "Active \"kill switch\" on GCP that queries BigQuery billing exports every 15 minutes and automatically unlinks the billing account if daily spend exceeds a cap - preventing runaway cloud costs. Handles GCP's 20-minute billing latency to avoid false positives.",
  },
];

const OtherProjects = () => {
  return (
    <section className="py-16 px-6 bg-darkSurface/30">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          variants={fadeInUp}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          className="section-header"
        >
          Other Projects
        </motion.h2>

        <motion.div
          variants={staggerContainer}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {otherProjects.map((project, index) => (
            <div key={index} className="other-project-wrapper">
              <motion.div variants={staggerItem} className="card h-full">
                <h3 className="text-lg font-semibold text-white mb-3">{project.title}</h3>
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.tags.map((tag, idx) => (
                    <span key={idx} className="tag">{tag}</span>
                  ))}
                </div>
                <p className="text-textSecondary text-sm leading-relaxed">{project.description}</p>
              </motion.div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default OtherProjects;
